import React, { useCallback, useEffect } from 'react';
import { DATE_ISO_FORMAT } from '../../../../../data/constants/datetime';
import { useDatesFromItems } from '../../../../../data/hooks/datetime/useDatesFromItems';
import RelativeRedirect from '../../../../elements/RelativeRedirect/RelativeRedirect';
import DateTabs from '../../../../elements/Tabs/DateTabs';

function DateSelection(props) {
    const { event, slots, date,updatingSlots, onChange } = props,
        dates = useDatesFromItems(event, slots, { format: DATE_ISO_FORMAT });

    const handleDateSelection = useCallback((date) => onChange(date.toISOString()), [onChange]);

    // when the current date isn't on the dates list, pick the first one
    useEffect(() => {
        if (dates.includes(date)) return;

        onChange(dates[0]);
    }, [dates, date]);

    if (!dates.length && !updatingSlots) {
        console.log('No dates available for meeting scheduling');
        return <RelativeRedirect to=".." />;
    }

    return <DateTabs dates={dates} value={date} onChange={onChange} />;
}

export default DateSelection;
